module.exports = __webpack_public_path__ + "static/media/justen.1652f7e9.jpg";